import { AxiosResponse } from "axios";

import { $axios } from "@/shared/api";

import { IGetHistoryParams, IGetHistoryResponse } from "../types";

class MessageHistoryService {
  async getHistory({ dialogId, cursor, limit }: IGetHistoryParams) {
    const params = new URLSearchParams();

    if (cursor) params.append("cursor", cursor);

    if (limit) params.append("limit", String(limit));

    const { data } = await $axios.get<
      IGetHistoryParams,
      AxiosResponse<IGetHistoryResponse>
    >(`/GetAIChatHistory/${dialogId}`, { params });
    return data;
  }
}

export const messageHistoryService = new MessageHistoryService();
